import React from "react";

export default function Item({ data }) {
	return (
		<div className="mb-8 max-w-2xl min-h-[650px]">
			<h3 className="text-2xl font-bold mb-4">{data.title}</h3>
			{/* Media */}
			{data.media && (
				<div className="mb-8">
					<img src={data.media} alt={data.title} width={400} />
				</div>
			)}
			{/* Body */}
			<div className="prose prose-lg text-gray-600">
				{Array.isArray(data.body) ? (
					data.body.map((text, idx) => (
						<div key={idx} className="mb-4 last:mb-0">
							{text}
						</div>
					))
				) : (
					<div>{data.body}</div>
				)}
			</div>
		</div>
	);
}
